(() => {
  const FREE_SHIPPING_THRESHOLD = 150;

  const SELECTORS = {
    drawer: "cart-drawer",
    subtotal: ".cart-drawer__footer .totals__total-value",
    message: "[data-free-shipping-message]",
    progress: "[data-free-shipping-progress]",
  };

  let lastSubtotal = null;
  let subtotalObserver = null;

  function parseMoney(text) {
    if (!text) return null;
    const cleaned = text.replace(/\s+/g, "").replace(/[^\d.,]/g, "");
    if (!cleaned) return null;
    // If both comma and dot exist, comma is a thousands separator → remove it
    // If only comma exists, treat it as decimal separator → replace with dot
    if (cleaned.includes(",") && cleaned.includes(".")) {
      return parseFloat(cleaned.replace(/,/g, ""));
    }
    return parseFloat(cleaned.replace(",", "."));
  }

  function getSubtotal() {
    const el = document.querySelector(SELECTORS.subtotal);
    return el ? parseMoney(el.textContent) : null;
  }

  function updateBar() {
    const subtotal = getSubtotal();
    if (subtotal === lastSubtotal) return;
    lastSubtotal = subtotal;

    const messageEl = document.querySelector(SELECTORS.message);
    const progressEl = document.querySelector(SELECTORS.progress);
    if (!messageEl || !progressEl) return;

    const barEl = messageEl.closest(".bg-orange");
    if (!barEl) return;

    if (!subtotal || subtotal <= 0) {
      messageEl.textContent = "Free Delivery on orders £150+";
      progressEl.style.width = "0%";
      return;
    }

    barEl.style.paddingBottom = "";

    const remaining = Math.max(FREE_SHIPPING_THRESHOLD - subtotal, 0);
    const progress = Math.min(Math.max((subtotal / FREE_SHIPPING_THRESHOLD) * 100, 0), 100);

    messageEl.textContent =
      remaining === 0
        ? "You’ve unlocked free shipping 🎉"
        : `You’re £${remaining.toFixed(2)} away from free shipping.`;

    progressEl.style.width = `${progress}%`;
  }

  function observeSubtotal() {
    if (subtotalObserver) subtotalObserver.disconnect();

    const subtotalEl = document.querySelector(SELECTORS.subtotal);
    if (!subtotalEl) return;

    subtotalObserver = new MutationObserver(updateBar);
    subtotalObserver.observe(subtotalEl, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    updateBar();
  }

  function init() {
    const drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;

    new MutationObserver(() => {
      observeSubtotal();
    }).observe(drawer, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
